export default {
  logout: 'Вы вышли из системы',
  login: 'Для начала войдите в систему',

  // Проверка кодов из EmptyLayout
  'auth/user-not-found': 'NoUseWithEmail',
  'auth/wrong-password': 'WrongPassword',
  'auth/email-already-in-use': 'EmailInUse'
}
